/*

TODO:
 -  ConfigObjectI better name for multiple uses

 */
import React, { useState, useRef, lazy, useEffect } from "react";
import RequestService from "../../utils/fetch";
import ListOfCitiesWithLatLng from "../../utils/ListOfCities";
import Filter from "../Filter";
const SkeletonList = lazy(() => import("../Skeleton/List"));
const List = lazy(() => import("../List"));
const Pagination = lazy(() => import("../Pagination"));
const ConditionalWrapper = lazy(() => import("../../utils/ConditionalWrapper"));
const GeoSearch = lazy(() => import("../GeoSearch/index"));
const GeoSearchClass = lazy(() => import("../GeoSearch/index.class"));
const JobagentHint = lazy(() => import("../JobagentHint"));
import translations from "../../translations";
import SkeletonFilter from "../Skeleton/Filter";
const TmsJobList = (props) => {
    return React.createElement(JobList, { props: props });
    //
    // return (
    //     <QueryClientProvider client={queryClient}>
    //         <JobList/>
    //     </QueryClientProvider>
    // )
};
function JobList(props) {
    const configName = "myTalentionConfig";
    const [configObject, setConfigObject] = useState(window[configName]);
    const [customClasses, setCustomClasses] = useState();
    const [jobListView, setJobListView] = useState(configObject.toggleViewBar?.initial ? String(configObject.toggleViewBar?.initial) : "tms-is-list-view");
    const [useCustomClasses, setUseCustomClasses] = useState(false);
    const [jobagentVisible, setJobagentVisible] = useState(false);
    const translationsJobList = translations[configObject.lang] ? translations[configObject.lang] : translations["de"];
    const GeoSearchRef = useRef(null);
    const filterRef = useRef([]);
    const [filterObject, setFilterObject] = useState({
        notProcessed: true,
        filter: {
            category: configObject.category || []
        },
        pagination: {
            offset: 0,
            max: configObject.pageSize || 10
        }
    });
    const [paginationObject, setPaginationObject] = useState({
        max: configObject.pageSize
    });
    const [pagination, setPagination] = useState(null);
    const [hasGeoConsent, setHasGeoConsent] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [isLoadingFeatured, setIsLoadingFeatured] = useState(true);
    const [extendedFilterIsOpen, setExtendedFilterIsOpen] = useState(false);
    const [hasPrefilter, setHasPrefilter] = useState(false);
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [preFilter, setPreFilter] = useState({
        filter: {},
        location: {}
    });
    const [data, setData] = useState();
    const [featuredData, setFeaturedData] = useState();
    const [listOfCities, setListOfCities] = useState([]);
    const [city, setCity] = useState("");
    const [geosearchObject, setGeosearchObject] = useState({
        city: "",
        radius: configObject?.geosearch?.diameters[0] || "10"
    });
    function handleCustomClass(name) {
        if (useCustomClasses === false) {
            return "";
        }
        if (customClasses[name] === undefined) {
            return "";
        }
        return customClasses[name];
    }
    ;
    async function extractTmsParams() {
        // Erstelle ein leeres Objekt, um die Parameter zu speichern
        const tmsParams = {};
        const tmsParamsGeo = {};
        let tmsAttributs = {};
        let tmsAttributsGeo = {};
        // Extrahiere den Teil der URL nach dem '?' (die Query-Parameter)
        const queryParams = new URLSearchParams(window.location.search);
        //@ts-ignore
        const attributParams = props.props["attribute"];
        if (attributParams.length) {
        }
        const blackList = ["tms-page", "tms-geosearch-"];
        let offsetPage = 0;
        queryParams.forEach((value, key) => {
            if (key.indexOf('tms-page') !== -1) {
                offsetPage = parseInt(value);
            }
            setPaginationObject((oldObj) => {
                return {
                    ...oldObj,
                    offset: (offsetPage - 1) * configObject.pageSize
                };
            });
            if (blackList.includes(key))
                return;
            if (key.startsWith('tms-') && key.indexOf('tms-geosearch') === -1) {
                const paramName = key.replace("tms-", "");
                tmsParams[paramName] = value.split(',');
            }
            if (key.startsWith('tms-geosearch-')) {
                const paramName = key.replace("tms-geosearch-", "");
                if (paramName === "diameter") {
                    tmsParamsGeo[paramName] = value;
                    tmsParamsGeo["radius"] = value;
                }
                else {
                    tmsParamsGeo[paramName] = value;
                }
            }
        });
        Object.keys(attributParams).forEach((key) => {
            const name = attributParams[key].name;
            const value = attributParams[key].value;
            if (name === "filter") {
                tmsAttributs = JSON.parse(value);
            }
            else {
                tmsAttributsGeo[name] = value;
            }
        });
        Object.keys(tmsAttributsGeo).forEach((key) => {
            tmsParamsGeo[key] = tmsAttributsGeo[key];
        });
        Object.keys(tmsAttributs).forEach((key) => {
            if (tmsParams[key] === undefined) {
                tmsParams[key] = [];
            }
            tmsParams[key].push(...tmsAttributs[key]);
        });
        return {
            filter: { ...tmsParams },
            location: { ...tmsParamsGeo },
            pagination: { max: configObject.pageSize, offset: offsetPage * configObject.pageSize }
        };
    }
    async function handleGeoCoding(city) {
        let output = {};
        const geocoder = new google.maps.Geocoder();
        await geocoder.geocode({
            address: decodeURIComponent(city)
        }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                output = {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng(),
                };
            }
        });
        return output;
    }
    function removeNonAlphaAndConvertUmlauts(str) {
        // Erst die Umlaute umwandeln
        str = str.replace(/ä/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ü/g, 'u')
            .replace(/Ä/g, 'A')
            .replace(/Ö/g, 'O')
            .replace(/Ü/g, 'U');
        // Dann alle Zeichen, die keine Buchstaben sind, entfernen
        return str.replace(/[^a-zA-Z]/g, "").toLowerCase();
    }
    useEffect(() => {
        if (configObject.featuredJobs?.active) {
            handleFeaturedJobsAPICall("useeffect[]");
        }
        let filter = {};
        // @ts-ignore
        if (location.href.indexOf('tms-') !== -1 || props.props["attribute"].length) {
            if (configObject.keepJobPrefilter) {
                setHasPrefilter(true);
            }
            extractTmsParams().then(data => {
                filter = {
                    ...data
                };
                if (data.location.city) {
                    setCity(data.location.city);
                    if (ListOfCitiesWithLatLng[removeNonAlphaAndConvertUmlauts(data.location.city)] !== undefined) {
                        filter.location.lat = ListOfCitiesWithLatLng[removeNonAlphaAndConvertUmlauts(data.location.city)].lat;
                        filter.location.lng = ListOfCitiesWithLatLng[removeNonAlphaAndConvertUmlauts(data.location.city)].lng;
                        setFilterObject(filter);
                        setPreFilter(filter);
                        setGeosearchObject(filter.location);
                    }
                    else {
                        // @ts-ignore
                        handleGeoCoding(data.location.city).then((data) => {
                            filter.location.lat = data.lat;
                            filter.location.lng = data.lng;
                            // console.log("handleGeocoding");
                            setFilterObject(filter);
                            setPreFilter(filter);
                            setGeosearchObject(filter.location);
                        });
                    }
                    return;
                }
                else {
                    setPreFilter(filter);
                    // console.log("else");
                    setFilterObject((oldObj) => {
                        return {
                            ...oldObj,
                            notProcessed: false,
                            filter: {
                                ...oldObj.filter,
                                ...filter.filter
                            }
                        };
                    });
                    return;
                }
            });
        }
        else {
            handleAPICall("useeffect[]");
        }
        window.dispatchEvent(new Event("TmsJobListLoaded")); // is loaded
        // @ts-ignore
        window['toggleSkeleton'] = () => {
            setIsLoading(old => !old);
        };
        //wusel
        // @ts-ignore
        window['TmsJoblist'] = {
            handleFilterReset: () => {
                handleFilterReset();
                const keys = Object.keys(filterRef.current);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if (key === "title") {
                        console.log(filterRef.current[key].handleFilterReset());
                    }
                    filterRef.current[key].handleFilterReset();
                }
            },
            handleFilterChange: (filterName, filterValue) => {
                filterRef.current[filterName].handleExternalChange(filterValue);
                handleFilterChange(filterName, filterValue);
            }
        };
        const giveMapsConsent = () => {
            if (hasGeoConsent)
                return;
            setHasGeoConsent(true);
        };
        window.addEventListener('CONSENT_MAPS', giveMapsConsent);
        if (configObject.useCustomClasses) {
            setUseCustomClasses(true);
            setCustomClasses({ ...configObject.customClasses.jobList });
        }
        return () => {
            window.removeEventListener('CONSENT_MAPS', giveMapsConsent);
        };
    }, []);
    useEffect(() => {
        isFilterEmpty(filterObject) ? setJobagentVisible(false) : setJobagentVisible(true);
        if (filterObject.notProcessed)
            return;
        handleAPICall('useeffect[filterObject]');
    }, [filterObject]);
    useEffect(() => {
        console.log("featuredData", featuredData);
        if (featuredData === undefined) {
            return;
        }
        setIsLoadingFeatured(false);
    }, [featuredData]);
    useEffect(() => {
        console.log("hasPrefilter", Object.keys(preFilter.filter).length);
        const filterKeys = Object.keys(preFilter.filter);
        let hasExtendedPreFilter = false;
        console.log("filterKeys", filterKeys);
        for (let i = 0; i < filterKeys.length; i++) {
            const constfilterKey = filterKeys[i];
            configObject.myFilter.forEach((filter) => {
                if (filter.name == constfilterKey && filter.extended) {
                    hasExtendedPreFilter = true;
                }
            });
        }
        if (hasExtendedPreFilter) {
            setExtendedFilterIsOpen(true);
        }
        // if (filterKeys.length) {
        //     setExtendedFilterIsOpen(true)
        // }
        // let hasExtendedPreFilter = configObject.myFilter.map((filter: any) => {})
        //
        // let hasExtendedPreFilter = configObject.myFilter.map((filter: any) => {
        //     let output = false;
        //     if (filter.extended) {
        //         return true
        //     }
        //     return false;
        // })
        //
        // console.log("hasExtendedPreFilter", hasExtendedPreFilter);
        // if (hasExtendedPreFilter.includes(true)) {
        //     setExtendedFilterIsOpen(true)
        // }
    }, [preFilter]);
    useEffect(() => {
        if (isFirstRender)
            return;
        window.dispatchEvent(new Event("TmsJobListFeedChanged")); // when stat of joblsit has changed
        if (configObject.jumpToTopAfterFetch) {
            const element = document.querySelector("#tms-joblist-wrap") || document.querySelector(configObject.jumpToTopAfterFetchID);
            const scrollIntoViewOptions = configObject.jumpToTopAfterFetchOptions || {
                behavior: "smooth",
            };
            element.scrollIntoView(scrollIntoViewOptions);
        }
        setIsFetching(false);
    }, [data]);
    useEffect(() => {
        // console.log("filterObject", filterObject);
        if (paginationObject === null)
            return;
        const currentPage = Math.floor(paginationObject?.offset / paginationObject.max) || 1;
        // console.table({currentPage: currentPage, offset: paginationObject?.offset, max: paginationObject.max});
        const maxPage = Math.ceil(paginationObject?.resultsTotal / paginationObject?.max);
        buildPagination(Number(currentPage), Number(maxPage));
    }, [paginationObject]);
    const isFilterEmpty = (filterObject) => {
        // Erste Sicherheitsüberprüfung: filterObject existiert
        if (!filterObject) {
            console.log("isFilterEmpty", 1);
            return true;
        }
        // Zweite Sicherheitsüberprüfung: filterObject.filter existiert
        if (!filterObject.filter) {
            console.log("isFilterEmpty", 2);
            return true;
        }
        // Dritte Sicherheitsüberprüfung: filterObject.filter ist ein Objekt
        if (typeof filterObject.filter !== 'object') {
            console.log("isFilterEmpty", 3);
            return true;
        }
        const keys = Object.keys(filterObject.filter).filter(key => key !== 'category');
        if (keys.length === 0) {
            return true;
        }
        // Prüfe ob alle Nicht-Category Keys leer sind
        return keys.every(key => {
            const value = filterObject.filter[key];
            if (value === null || value === undefined) {
                return true;
            }
            if (Array.isArray(value)) {
                return value.length === 0;
            }
            if (typeof value === 'string') {
                return value.trim() === '';
            }
            return false;
        });
    };
    function handleGeoSearch(geoValue) {
        if (geosearchObject.radius && geoValue.radius === undefined) {
            geoValue.radius = geosearchObject.radius;
        }
        if (Object.keys(geoValue).length === 0) {
            setCity("");
            setGeosearchObject({
                city: "",
                radius: configObject.geosearch.diameters[0] || "10"
            });
            return;
        }
        setCity(geoValue.city);
        setGeosearchObject((oldObj) => {
            return {
                ...oldObj,
                ...geoValue
            };
        });
        setFilterObject((oldObj) => {
            return {
                ...oldObj,
                notProcessed: false,
                location: {
                    ...oldObj.location,
                    ...geoValue
                }
            };
        });
    }
    function handleFilterRemove(filterName, filterValue) {
        // console.log("handleFilterRemove");
        setFilterObject((oldObj) => {
            const index = oldObj.filter[filterName].indexOf(filterValue);
            oldObj.filter[filterName].splice(index, 1);
            return {
                ...oldObj,
                pagination: {
                    ...oldObj.pagination,
                    offset: 0
                },
            };
        });
        // console.log("handleFilterRemove", filterName, filterValue);
        // console.log("filterObject>", filterObject);
    }
    function buildPagination(c, m, where) {
        console.log("where", where);
        console.log("c", c, "m", m);
        // c = current page
        // m = max pages
        if (c === undefined || m === undefined) {
            return;
        }
        if (c < 1) {
            c = 1;
        }
        let rangeWithDots = [];
        if (configObject.paginationType === "hide-last") {
            const current = c;
            const last = m;
            const delta = 2;
            const left = current - delta;
            const right = current + delta + 1;
            const range = [];
            let l;
            for (let i = 1; i <= last; i++) {
                if (i >= left && i < right) {
                    range.push(i);
                }
            }
            for (const i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
        }
        else {
            const current = c;
            const last = m;
            const delta = 2;
            const left = current - delta + 1;
            const right = current + delta + 1;
            const range = [];
            let l;
            for (let i = 1; i <= last; i++) {
                if (i === 1 || i === last || (i >= left && i < right)) {
                    range.push(i);
                }
            }
            for (const i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    }
                    else if (i - l !== 1) {
                        rangeWithDots.push("...");
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
        }
        if (!rangeWithDots.length) {
            rangeWithDots = [1];
        }
        console.log(rangeWithDots);
        setPagination(rangeWithDots);
    }
    function handleFilterSubmit() {
        const form = document.querySelector("#tms-filter-wrap");
        const inputs = form.querySelectorAll(".tms-filter-item--input input");
        const payload = {};
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            if (input.value) {
                if (filterObject.filter[input.dataset.tmsName] !== undefined && filterObject.filter[input.dataset.tmsName].indexOf(input.value) !== -1) {
                    return;
                }
                if (filterObject.filter[input.dataset.tmsName] !== undefined) {
                    payload[input.dataset.tmsName] = filterObject.filter[input.dataset.tmsName];
                    if (filterObject.filter[input.dataset.tmsName].indexOf(input.value) === -1) {
                        payload[input.dataset.tmsName].push(input.value);
                    }
                }
                else {
                    payload[input.dataset.tmsName] = [input.value];
                }
                filterRef.current[input.dataset.tmsName].addToItems({
                    value: input.value,
                    label: input.value
                });
                filterRef.current[input.dataset.tmsName].setState({
                    currentValue: ""
                });
                // console.log(filterRef.current[input.dataset.tmsName].filterElement.current.input.value = "");
            }
        }
        if (Object.keys(filterObject.filter).length === 1 && Object.keys(payload).length === 0) {
            return;
        }
        setFilterObject((oldObj) => {
            return {
                ...oldObj,
                notProcessed: false,
                filter: {
                    ...oldObj.filter,
                    ...payload
                }
            };
        });
    }
    function handleFilterReset() {
        if (Object.keys(filterObject.filter).length === 1 && (filterObject.location === undefined || Object.keys(filterObject?.location).length === 0) && filterObject.pagination.offset === 0 && paginationObject.offset === 0) {
            return;
        }
        // console.log("handleFilterReset");
        let locationPayload = {};
        let filterPayload = {};
        if (configObject.keepJobPrefilter) {
            if (preFilter.location) {
                locationPayload = preFilter.location;
            }
            if (preFilter.filter) {
                filterPayload = preFilter.filter;
            }
        }
        else {
            setPreFilter({
                filter: {},
                location: {}
            });
            setExtendedFilterIsOpen(false);
        }
        setPaginationObject((oldObj) => {
            return {
                ...oldObj,
                offset: 0
            };
        });
        if (hasPrefilter) {
            setGeosearchObject({ ...preFilter.location });
        }
        else {
            if (configObject.geosearch && GeoSearchRef.current !== null) {
                GeoSearchRef.current.resetGeoObject();
            }
            setCity("");
            setGeosearchObject((oldObj) => {
                return { ...oldObj, city: "", lat: "", lng: "" };
            });
        }
        setFilterObject((oldObj) => {
            return {
                location: {
                    ...locationPayload
                },
                notProcessed: false,
                pagination: {
                    ...oldObj.pagination,
                    offset: 0
                },
                filter: {
                    category: configObject.category,
                    ...filterPayload
                }
            };
        });
        /*
        Loop through all ref of filter element,
        check if this is a dropdown based on a function
        which should be available. Otherwise, call the input function
         */
        const filterKeys = Object.keys(filterRef.current);
        filterKeys.forEach(filterKey => {
            if (filterRef.current[filterKey] === null)
                return;
            const { filterElement } = filterRef.current[filterKey];
            if (typeof filterElement.current.clearDropdown === "function") {
                filterElement.current.clearDropdown();
            }
            else {
                filterRef.current[filterKey].resetValues();
            }
        });
        window.history.replaceState({}, document.title, location.href.split("?")[0]);
    }
    function handleFilterChange(filterName, filterValue) {
        // console.log("handleFilterChange");
        let filterValueArray = filterValue.map((item) => {
            return item.value;
        });
        setPaginationObject((oldObj) => {
            return {
                ...oldObj,
                offset: 0
            };
        });
        setFilterObject((oldObj) => {
            return {
                ...oldObj,
                notProcessed: false,
                pagination: {
                    ...oldObj.pagination,
                    offset: 0
                },
                filter: {
                    ...oldObj.filter,
                    [filterName]: filterValueArray
                }
            };
        });
    }
    function handleFeaturedJobsAPICall(where) {
        const { featuredJobs } = configObject;
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: {
                [featuredJobs.property]: featuredJobs.value
            },
            sorter: {
                sort: configObject.jobSorter || "enabledDate",
                order: configObject.jobSorterOrder || "desc"
            },
            pagination: {
                max: featuredJobs.maxResults
            }
        }).then((featured) => {
            setFeaturedData(featured);
        });
    }
    ;
    function handleAPICall(where) {
        console.log("where", where);
        setIsFetching(true);
        const paginationPayload = paginationObject?.max ? paginationObject?.max : configObject.pageSize;
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: filterObject.filter,
            location: filterObject.location,
            sorter: {
                sort: configObject.jobSorter || "enabledDate",
                order: configObject.jobSorterOrder || "desc"
            },
            pagination: {
                ...paginationObject,
                max: Number(paginationPayload)
            }
        }).then((jobs) => {
            // @ts-ignore
            setData(jobs);
            setPaginationObject((oldObj) => {
                if (JSON.stringify(oldObj) === JSON.stringify({
                    resultsTotal: jobs.resultsTotal,
                    max: jobs.maxResults,
                    offset: Number(jobs.offset),
                }))
                    return oldObj;
                return {
                    ...oldObj,
                    resultsTotal: jobs.resultsTotal,
                    max: Number(jobs.maxResults),
                    offset: jobs.offset,
                };
            });
            if (isLoading) {
                setIsLoading(false);
            }
            if (isFirstRender) {
                setIsFirstRender(false);
            }
        });
    }
    function handlePageSizeChange(e) {
        setPaginationObject((oldObj) => {
            return {
                ...oldObj,
                offset: 0,
                max: Number(e[0].value)
            };
        });
        setFilterObject((oldObj) => {
            return {
                ...oldObj,
                notProcessed: false,
                pagination: {
                    ...oldObj.pagination,
                    offset: 0,
                    max: Number(e[0].value)
                }
            };
        });
        window.history.replaceState({}, document.title, location.href.split("?")[0]);
    }
    const createMarkup = (html) => {
        return { __html: html };
    };
    function handleJobListView(state) {
        setJobListView(state);
    }
    function handlePaginationClick(e) {
        const offset = Number(e) - 1;
        setPaginationObject((oldObj) => {
            return {
                ...oldObj,
                offset: Number(offset) * Number(paginationObject.max)
            };
        });
        setFilterObject((oldObj) => {
            return {
                ...oldObj,
                notProcessed: false,
                pagination: {
                    ...oldObj.pagination,
                    offset: Number(offset) * Number(paginationObject.max)
                }
            };
        });
    }
    const allowedTypes = ["select", "input"];
    const MaxResultsTag = configObject?.customMaxResultsText?.tag || "h1";
    const GeoComponent = typeof configObject.geosearch?.version === "undefined" ? GeoSearchClass : GeoSearch;
    // @ts-ignore
    return (React.createElement(React.Fragment, null, isLoading ? React.createElement(React.Fragment, null,
        configObject.hideFilter ? null : React.createElement(SkeletonFilter, { filter: 3 }),
        React.createElement(SkeletonList, { filter: 3, count: 5 }))
        : React.createElement("div", { id: "tms-joblist-wrap" },
            !configObject.hideMaxResults && (React.createElement("section", { className: "joblist-maxresults" },
                React.createElement(MaxResultsTag, null,
                    configObject?.customMaxResultsText?.prepend && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--prepend", dangerouslySetInnerHTML: createMarkup(configObject?.customMaxResultsText?.prepend) })),
                    React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--hits" }, paginationObject?.resultsTotal),
                    " ",
                    paginationObject?.resultsTotal === 1 ? configObject?.customMaxResultsText?.single || translationsJobList.jobFoundSingle : configObject?.customMaxResultsText?.multiple || translationsJobList.jobFoundMultiple,
                    configObject?.customMaxResultsText?.append && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--append", dangerouslySetInnerHTML: createMarkup(configObject?.customMaxResultsText?.append) }))))),
            configObject.hideFilter ? null : React.createElement("div", { id: "tms-filter-wrap", className: "tms-filter-wrap" },
                React.createElement(ConditionalWrapper, { condition: !configObject.disableFilterWrap, wrapper: (children) => (React.createElement("div", { className: ["tms-filter-item-wrap"].join(" ") }, children)) },
                    configObject.myFilter?.map((filter, key) => {
                        if ((configObject.useExtendedFilter === undefined || configObject.useExtendedFilter === false) || (filter.extended !== true || filter.extended === undefined)) {
                            return React.createElement(Filter, { key: key, ref: allowedTypes.includes(filter.type) ? el => filterRef.current[filter.name] = el : null, preFilter: preFilter.filter, config: configObject, showFancyOverlay: () => {
                                }, handleFilterRemove: handleFilterRemove, translations: translationsJobList, handleFilterChange: handleFilterChange, filter: filter });
                        }
                    }),
                    configObject?.geosearch?.active && hasGeoConsent ?
                        React.createElement(GeoComponent, { ref: GeoSearchRef, handleListOfCities: setListOfCities, listOfCities: listOfCities, handleCity: setCity, city: city, showFancyOverlay: () => {
                            }, handleGeoSearch: handleGeoSearch, geosearchObject: geosearchObject, diameters: configObject.geosearch.diameters || [10, 25, 100, 250] }) : null,
                    React.createElement(ConditionalWrapper, { condition: configObject.useExtendedFilter, wrapper: (children) => (React.createElement("div", { className: ["tms-filter-item-wrap-extended"].join(" ") },
                            configObject.useExtendedFilter ?
                                React.createElement("div", { className: "tms-button--extended-filter-wrapper" },
                                    React.createElement("button", { className: extendedFilterIsOpen ? "tms-button--extended-filter-close" : "tms-button--extended-filter-open", onClick: () => setExtendedFilterIsOpen(!extendedFilterIsOpen) }, extendedFilterIsOpen ? configObject.myFilterCustomText?.extendedFilterButtonClose || translationsJobList.close.toString() : configObject.myFilterCustomText?.extendedFilterButtonOpen || translationsJobList.open.toString())) : null,
                            children)) },
                        React.createElement("div", { className: "tms-extended-filter-wrapper" }, extendedFilterIsOpen && configObject.myFilter?.map((filter, key) => {
                            if (filter.extended === true) {
                                return React.createElement(Filter, { key: key, ref: allowedTypes.includes(filter.type) ? el => filterRef.current[filter.name] = el : null, preFilter: preFilter.filter, config: configObject, showFancyOverlay: () => {
                                    }, handleFilterRemove: handleFilterRemove, translations: translationsJobList, handleFilterChange: handleFilterChange, filter: filter });
                            }
                        })))),
                configObject.myFilter ? React.createElement(ConditionalWrapper, { condition: !configObject.disableButtonWrap, wrapper: (children) => (React.createElement("div", { className: ["tms-filter-button-wrap"].join(" ") }, children)) },
                    React.createElement("button", { className: `tms-filter-button tms-filter-button--submit ${handleCustomClass("searchButton") || ""} `, onClick: () => {
                            handleFilterSubmit();
                        }, type: "submit" }, translationsJobList.search),
                    React.createElement("button", { className: `tms-filter-button tms-filter-button--reset ${handleCustomClass("resetButton") || ""}`, onClick: () => {
                            handleFilterReset();
                        }, disabled: (filterObject.location?.lat === undefined && Object.keys(filterObject.filter).length === 1 && paginationObject?.offset === 0), type: "reset" }, translationsJobList.reset)) : null),
            jobagentVisible ? React.createElement(JobagentHint, { configObject: configObject, geosearchObject: geosearchObject, filterObject: filterObject.filter, translation: translationsJobList }) : null,
            configObject.enableJobFeedToggleViewButton ?
                React.createElement("div", { className: "tms-joblist-toggle-view-button-wrapper" },
                    React.createElement("button", { "aria-label": `${String(translationsJobList.list)}`, onClick: () => handleJobListView("tms-is-list-view"), className: `${jobListView === "tms-is-list-view" ? "tms-list-is-active" : ""} tms-joblist-toggle-view-button tms-joblist-toggle-view-button--list ${configObject.toggleViewBar?.buttonListClasses ? configObject.toggleViewBar?.buttonListClasses.join(" ") : ""}` }, configObject.toggleViewBar?.showButtonTextList ? String(configObject.toggleViewBar?.buttonTextList || translationsJobList.list) : null),
                    React.createElement("button", { "aria-label": `${String(translationsJobList.grid)}`, onClick: () => handleJobListView("tms-is-grid-view"), className: `${jobListView === "tms-is-grid-view" ? "tms-grid-is-active" : ""} tms-joblist-toggle-view-button tms-joblist-toggle-view-button--grid ${configObject.toggleViewBar?.buttonGridClasses ? configObject.toggleViewBar?.buttonGridClasses.join(" ") : ""}` }, configObject.toggleViewBar?.showButtonTextGrid ? String(configObject.toggleViewBar?.buttonTextGrid || translationsJobList.grid) : null)) : null,
            React.createElement(ConditionalWrapper, { condition: configObject.featuredJobs?.active, wrapper: (children) => (React.createElement("div", { className: ["tms-joblist-wrapper"].join(" ") }, children)) },
                isLoadingFeatured ? null :
                    React.createElement(ConditionalWrapper, { condition: configObject.featuredJobs?.active, wrapper: (children) => (React.createElement("div", { id: "tms-featured-jobs-wrapper", className: ["tms-featured-jobs"].join(" ") }, children)) },
                        React.createElement(List, { attributes: configObject.link, feedId: "tms-featured-jobfeed", customClasses: jobListView, parameter: configObject.parameterQuery, jobSorter: configObject.jobSorter, showJoblistButton: configObject.showJoblistButton, handleCustomClass: handleCustomClass, showJobListApplyButton: configObject.showJobListApplyButton, applyButtonText: configObject.applyButtonText, jobListButtonText: configObject.jobListButtonText, disableJoblistLink: configObject.disableJoblistLink, whatsapp: configObject.whatsapp, jobListProperties: configObject.jobListProperties, disableJobListTitleWrap: configObject.disableJobListTitleWrap, disableJobListPropertyWrap: configObject.disableJobListPropertyWrap, items: featuredData.results })),
                (isLoading || isFetching) ? React.createElement(SkeletonList, { filter: 3, count: 5 }) : React.createElement(List, { attributes: configObject.link, parameter: configObject.parameterQuery, jobSorter: configObject.jobSorter, showJoblistButton: configObject.showJoblistButton, customClasses: jobListView, handleCustomClass: handleCustomClass, showJobListApplyButton: configObject.showJobListApplyButton, applyButtonText: configObject.applyButtonText, jobListButtonText: configObject.jobListButtonText, disableJoblistLink: configObject.disableJoblistLink, whatsapp: configObject.whatsapp, jobListProperties: configObject.jobListProperties, disableJobListTitleWrap: configObject.disableJobListTitleWrap, disableJobListPropertyWrap: configObject.disableJobListPropertyWrap, items: data.results })),
            configObject.hidePagination ? null : React.createElement("div", { id: "tms-pagination-wrap", className: "tms-pagination-wrap" },
                React.createElement(Pagination, { handlePageSizeChange: handlePageSizeChange, handlePaginationClick: handlePaginationClick, pagination: pagination, buildPagination: buildPagination, config: configObject, number: Math.ceil(paginationObject?.resultsTotal / paginationObject?.max), active: Math.ceil(paginationObject?.offset / paginationObject?.max) })))));
}
export default TmsJobList;
